import { createAsyncThunk } from '@reduxjs/toolkit';

import { Api } from 'old-store/utils';

export const fetchBanners = createAsyncThunk('banners/fetchAll', async () => {
  const response = await Api.Collection.fetchBannersData(window.SITE_ID);

  return response.result;
});
